// extracted by mini-css-extract-plugin
export default {"account":"AccountMenu_account__ORSaD","trigger":"AccountMenu_trigger__TRy8W","menu":"AccountMenu_menu__6PVwJ","menuOpen":"AccountMenu_menuOpen__Op9xJ"};